// extracted by mini-css-extract-plugin
module.exports = {"registration":"account-settings_registration__UJL_0","left":"account-settings_left__ncZUU","generatedPrivacy":"account-settings_generatedPrivacy__V9a2M"};